import React from "react";
// import components
import PageHeading from "../components/PageHeading";
import DashboardAnalysisCards from "../components/DashboardAnalysisCards";
import Table from "../components/Table";
import DCard from "../components/DCard";
import DSpinner from "../components/DSpinner";
import DButton from "../components/DButton";
// import utils

import { useQueries } from "react-query";
import userServices from "../services/users";
import orderServices from "../services/orders";
import { icon } from "../utils/icons";
import productServices from "../services/products";
import moment from "moment/moment";

import {
    availableSorrundWithButton,
    formattedLevel,
    orderStatusBtnStyle,
    statusMessage,
} from "../utils/functions";
import { useSelector } from "react-redux";

const userColumns = [
    { Header: "اسم المستخدم", accessor: "username" },
    { Header: "الاسم", accessor: "name" },
    { Header: "تاريخ الانشاء", accessor: "created_at" },
    { Header: "الرصيد", accessor: "balance" },
    { Header: "المستوى", accessor: "level" },
    { Header: "متاح/غير متاح", accessor: "is_available" },
];
const ordersColumns = [
    { Header: "اسم المنتج", accessor: "name" },
    { Header: "المعرف الخارجي", accessor: "external_id" },
    { Header: "السعر", accessor: "total_cost" },
    { Header: "الكمية", accessor: "amount" },
    { Header: "اسم المستخدم", accessor: "username" },
    { Header: "تاريخ الطلب", accessor: "created_at" },
    { Header: "حالة الطلب", accessor: "status" },
];
const Dashboard = ({ title }) => {
    const { categories } = useSelector(state => state.config);
    const results = useQueries([
        {
            queryKey: ["totalUsers"],
            queryFn: () => {
                return userServices.getAllUsers().then(res => res.data);
            },
        },

        {
            queryKey: ["totalProducts"],
            queryFn: () => productServices.getAllProducts(),
        },
        {
            queryKey: ["getOrders"],
            queryFn: () => orderServices.getAllOrders(),
        },
        {
            queryKey: ["totalOrders"],
            queryFn: () => orderServices.getDailyOrdersInfo(),
        },
        {
            queryKey: ["getTotalUserBalance"],
            queryFn: () => userServices.getTotalUserBalance(),
        },
        {
            queryKey: ["getTotalUserBalance"],
            queryFn: () => userServices.getTotalUserBalance(),
        },
    ]);

    const formattedUserData = data => {
        if (data?.length > 0) {
            return data
                .map(d => ({
                    ...d,
                    is_available: d.is_available === 1 ? "متاح" : "غير متاح",
                    created_at: moment(d.created_at).format(
                        "hh:mm:ss YYYY-MM-DD"
                    ),
                    level: formattedLevel(d.level),
                }))
                .slice(0, 10);
        }
        return [];
    };
    const formattedData = data => {
     
        const info = data
            .filter((d, index) => index !== 1 && index < 3)
            .map((d, index) => {
                if (d.error) {
                    return {
                        loading: false,
                        total: 0,
                    };
                }
                return {
                    loading: d.isLoading,
                    total: d.total,
                };
            });

        info.push({
            loading: data[3].isLoading,
            total: data[3].data?.data.data.count,
        });

        info.push({
            loading: data[3].isLoading,
            total: data[3].data?.data.data.sum
                ? +data[3].data?.data.data.sum.toFixed(6) + "$"
                : "0$",
        });
        info.push({
            loading: data[4].isLoading,
            total: data[4].data?.data.balances
                ? +data[4].data?.data.balances.toFixed(6) + "$"
                : "0$",
        });
        info.push({
            loading: data[5].isLoading,
            total: data[5].data?.data.emergency_balances
                ? +data[5].data?.data.emergency_balances.toFixed(6) + "$"
                : "0$",
        });
        return [
            {
                id: 1,
                name: "المستخدمين",
                total: info[0].total,
                icon: icon.user,
                loading: info[0].loading,
            },
            {
                id: 2,
                name: "المنتجات",
                total: info[1].total,
                icon: icon.products,
                loading: info[1].loading,
            },
            {
                id: 3,
                name: "الطلبات اليومية",
                total: info[2].total,
                icon: icon.orders,
                loading: info[2].loading,
            },

            {
                id: 4,
                name: "التحويلات اليومية",
                total: info[3].total,
                icon: icon.dollar,
                loading: info[3].loading,
            },
            {
                id: 5,
                name: "ارصدة المستخدمين",
                total: info[4].total,
                icon: icon.dollar,
                loading: info[4].loading,
            },
            {
                id: 6,
                name: "الاقسام",
                total: categories.data?.length - 1 || 0,
                icon: icon.products,
                loading: categories.loading,
            },            {
                id: 7,
                name: "مجموع أرصدة الدين",
                total: info[5].total,
                icon: icon.dollar,
                loading: info[5].loading,
            },
        ];
    };
    const formattedOrdersData = data => {
        if (data?.data.data.length > 0) {
            return data.data.data
                .map(d => ({
                    ...d,
                    name: d.subitem.name,
                    external_id: d.external_id ? d.external_id : "لايوجد",
                    status: statusMessage(d.status),
                    created_at: moment(d.created_at).format(
                        "hh:mm:ss YYYY-MM-DD"
                    ),
                    username: d.user.username,
                }))
                .slice(0, 10);
        }
        return [];
    };
    const statusSorrundWithButton = cell => {
        return (
            <DButton
                className={`${
                    cell.value === "في الانتظار"
                        ? "text-third-color"
                        : "text-white"
                } min-w-[100px] rounded-[50px_!important]`}
                bgColor={orderStatusBtnStyle(cell.value)}
            >
                {cell.render("Cell")}
            </DButton>
        );
    };

    return (
        <div>
            <PageHeading>{title}</PageHeading>
            <DashboardAnalysisCards data={formattedData(results)} />
            <DCard className="min-h-[400px] relative mb-4">
                {results[1].isLoading ? (
                    <DSpinner />
                ) : (
                    <Table
                        head={ordersColumns}
                        body={formattedOrdersData(results[2].data)}
                        elements={{ status: statusSorrundWithButton }}
                    />
                )}
            </DCard>
            <DCard className="min-h-[400px] relative mb-4">
                {results[0].isLoading ? (
                    <DSpinner />
                ) : (
                    <Table
                        head={userColumns}
                        body={formattedUserData(results[0].data?.data.data)}
                        elements={{
                            is_available: availableSorrundWithButton,
                        }}
                    />
                )}
            </DCard>
        </div>
    );
};

export default Dashboard;
